import { all, fork, takeLatest, call, put, select } from 'redux-saga/effects';
import actions from './actions';
import config from '../../settings';
import request from '../../helpers/request';
import { makeSelectToken } from '../auth/selector';

export function* getUser() {
  yield takeLatest(actions.GET_USER, function*(action) {
    const idToken = yield select(makeSelectToken());
    const { userId } = action;

    try {
      const result = yield call(request, `${config.apiUrl}/users/${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${idToken}`,
        },
      });

      yield put(actions.getUserSuccess(result));
    } catch (error) {
      yield put(actions.getUserError(error));
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getUser),
  ]);
}
